(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // If AMD is supported and the global object (window) in case any JS module is expecting
    // the analyticsHelper to exists on the window object.
    define('analyticsHelper',[],
      () => {
        global.analyticsHelper = factory(global);
        return global.analyticsHelper;
      });
  } else if (typeof exports === 'object') {
    // If supports for Common JS is available export the module
    // and pass is value to the global (window) object in case non Common JS code
    // is expected to work with this analyticsHelper Module.
    global.analyticsHelper = factory(global);
    module.exports = global.analyticsHelper;
  } else {
    // If not support for AMD or Common JS is available register the module in the global scope.
    global.analyticsHelper = factory(global);
  }
}(typeof window !== 'undefined' ? window : {}, (root) => {
  'use strict';

  const CONFIGURATION = (function () {
    const constants = {
      nhsTrackingId: 'UA-40843711-4'
    };

    const get = function (key) {
      return constants[key];
    };

    return {
      get
    };
  }());

  /**
    * Helper to get values from google analytics trackers.
    * For reference:
    * {@link https://developers.google.com/analytics/devguides/collection/analyticsjs/ga-object-methods-reference}.
    * @param {array} keys Key Values we want to get from the tracker.
    * @returns {object} values Object with key/values pairs containing the requested key values.
    */
  const getGoogleAnalyticsValues = function (keys) {
    const nhsTrackingId = CONFIGURATION.get('nhsTrackingId');

    const trackers = root.ga.getAll().filter((element) => element.get('trackingId') === nhsTrackingId);
    const values = {};

    for (let i = 0; i < trackers.length; i += 1) {
      for (let j = 0; j < keys.length; j += 1) {
        if (values[keys[j]]) {
          // eslint-disable-next-line no-continue
          continue;
        }

        values[keys[j]] = trackers[i].get(keys[j]);
      }
    }

    return values;
  };

  const addAnalyticsUrlParameters = function (urlToWork) {
    let url = urlToWork;
    const analyticsValues = getGoogleAnalyticsValues(['clientId', 'userId']);

    const gaClientId = analyticsValues.clientId !== undefined
      ? analyticsValues.clientId
      : '';
    const gaUserId = analyticsValues.userId !== undefined
      ? analyticsValues.userId
      : '';

    if (gaClientId) {
      url = url + '/GAClientId-' + gaClientId;
    }

    if (gaUserId) {
      url = url + '/GAUserId-' + gaUserId;
    }

    return url;
  };

  return {
    addAnalyticsUrlParameters,
    getGoogleAnalyticsValues
  };
}));

